import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from '@emotion/styled';

const ArrowContainer = styled.div`
    padding: 12px;
    border: 2px solid rgba(255, 255, 255, 0.23);
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const LeftArrow = (props: any) => (
    <ArrowContainer {...props}>
        <FontAwesomeIcon
            icon={faChevronLeft}
            color="white"
            style={{ width: 24, height: 24 }}
        />
    </ArrowContainer>
);

export const RightArrow = (props: any) => (
    <ArrowContainer {...props}>
        <FontAwesomeIcon
            icon={faChevronRight}
            color="white"
            style={{ width: 24, height: 24 }}
        />
    </ArrowContainer>
);
